import L from 'leaflet';
import { BlackOpacity60, Blue80 } from '@traceair/tds';
import { Site } from '../../../../../types';
import { useRef } from 'react';

export const useAddSiteBoundary = (site: Site) => {
  const boundaryLayerRef = useRef<L.Polygon | null>(null);
  const boundaryLayerRefBorder = useRef<L.Polygon | null>(null);

  const addSiteBoundary = (map: L.Map) => {
    const coordinates = site.boundary?.geometry.coordinates[0].map((coord) => [coord[1], coord[0]] as [number, number]);

    boundaryLayerRefBorder.current = L.polygon(coordinates, {
      pane: 'tooltipPane',
      color: BlackOpacity60,
      weight: 3,
      fill: false,
    }).addTo(map);
    boundaryLayerRef.current = L.polygon(coordinates, {
      pane: 'tooltipPane',
      color: Blue80,
      fillOpacity: 0.5,
    }).addTo(map);

    map.fitBounds(boundaryLayerRef.current.getBounds());
  };

  return {
    addSiteBoundary,
    boundaryLayerRef,
    boundaryLayerRefBorder,
  };
};
